import gql from 'graphql-tag';

export const updateExternalContactList = gql`
  mutation updateExternalContactList(
    $id: ID!
    $input: ExternalContactListInput
  ) {
    updateExternalContactList(id: $id, input: $input) {
      id
      name
      notes
      createdAt
      updatedAt
      deletedAt
      updater
      ExternalContactListMembers {
        id
        name
        description
        phone
        order
      }
      BusinessUnits {
        id
        name
      }
    }
  }
`;
